<mat-form-field class="mat-field-width">
    <mat-select [formControl]="control"
            #selectControl>
        <span class="search-fixed-panel">
            <span class="search-input-container">
                <input #searchInput
                    matInput 
                    type="text" 
                    autocomplete="off"
                    [formControl]="searchControl"
                    (blur)="onSearchBlur()"
                    class="search-input">
                <span>
                    <button mat-button (click)="searchControl.setValue('');searchInput.focus()" title="Clear search">
                        <mat-icon>close</mat-icon>
                    </button>
                </span>
            </span>
        </span>
        <span class="select-panel">
            <mat-option *ngFor="let a of filteredAccounts | async"
                    [value]="a.id">
                <app-nested-account-name [nestLevel]="a.nestLevel"
                        [name]="a.name">
                </app-nested-account-name>                    
            </mat-option>
        </span>
    </mat-select>
    <span matSuffix>
        <button mat-button (click)="refreshRequest($event)" title="Reload nominal account list">
            <mat-icon>refresh</mat-icon>
        </button>
    </span>
    <mat-error *ngIf="error">
        {{error}}
    </mat-error>
</mat-form-field>
